import { useAppLocales } from '~/composables/useAppLocales';
import {
  getProtocolRedirectDestination,
  localeFromRoutePath,
} from '~/utils/getProtocolRedirectDestination';


export default defineNuxtRouteMiddleware((to) => {
  const { excludedLocales, fallbackLocale } = useAppLocales();
  const destination = getProtocolRedirectDestination(
    to.query.target,
    localeFromRoutePath(to.path),
    excludedLocales.value,
    fallbackLocale.value,
  );

  return navigateTo(destination, { replace: true });
});
